//Natioanlity
export const GetAllNationalityLookup = 'api/Lookup/Nationality/GetAll';
export const AddNationalityLookup = 'api/lookup/Nationality/Add';
export const updateNationalityLookup = 'api/lookup/Nationality/update';
export const DeleteNationalityLookup = 'api/lookup/Nationality/delete';

//Leave Type
export const GetAllLeaveTypeLookup = 'api/Lookup/LeaveType/GetAll';
export const AddLeaveTypeLookup = 'api/lookup/LeaveType/Add';
export const UpdateLeaveTypeLookup = 'api/lookup/LeaveType/update';
export const DeleteLeaveTypeLookup = 'api/lookup/LeaveType/delete';

// Religion
export const GetAllReligionLookup = 'api/Lookup/Religion/GetAll';
export const AddReligionLookup = 'api/lookup/Religion/Add';
export const updateReligionLookup = 'api/lookup/Religion/update';
export const DeleteReligionLookup = 'api/lookup/Religion/delete';

// Designation
export const GetAllDesignationLookup = 'api/lookup/Designation/GetAll';
export const AddDesignationLookup = 'api/lookup/Designation/Add';
export const UpdateDesignationLookup = 'api/lookup/Designation/update';
export const DeleteDesignationLookup = 'api/lookup/Designation/delete';

// DesignationCategory
export const GetAllDesignationCategoryLookup =
  'api/lookup/Designation/DesignationCategoryGetAll';
export const AddDesignationCategoryLookup =
  'api/lookup/Designation/DesignationCategoryAdd';
export const UpdateDesignationCategoryLookup =
  'api/lookup/Designation/DesignationCategoryUpdate';
export const DeleteDesignationCategoryLookup =
  'api/lookup/Designation/DesignationCategoryDelete';

//Job Grade
export const GetAllJobGradeLookup = 'api/lookup/JobGrade/GetAll';
export const AddJobGradeLookup = 'api/lookup/JobGrade/Add';
export const UpdateJobGradeLookup = 'api/lookup/JobGrade/update';
export const DeleteJobGradeLookup = 'api/lookup/JobGrade/delete';

//User Type
export const GetAllUserTypeLookup = 'api/lookup/UserType/GetAll';
export const AddUserTypeLookup = 'api/lookup/UserType/Add';
export const UpdateUserTypeLookup = 'api/lookup/UserType/update';
export const DeleteUserTypeLookup = 'api/lookup/UserType/delete';

//Work Location
export const GetAllWorkLocationLookup = 'api/lookup/WorkLocation/GetAll';
export const AddWorkLocationLookup = 'api/lookup/WorkLocation/Add';
export const updateWorkLocationLookup = 'api/lookup/WorkLocation/update';
export const DeleteWorkLocationLookup = 'api/lookup/WorkLocation/delete';

//Employee Exception
export const GetAllEmployeeExceptionLookup =
  'api/lookup/EmployeeException/GetAll';
export const AddEmployeeExceptionLookup = 'api/lookup/EmployeeException/Add';
export const UpdateEmployeeExceptionLookup =
  'api/lookup/EmployeeException/update';
export const DeleteEmployeeExceptionLookup =
  'api/lookup/EmployeeException/delete';

//Reader
export const GetAllReaderLookup = 'api/lookup/Reader/GetAll';
export const AddReaderLookup = 'api/lookup/Reader/Add';
export const UpdateReaderLookup = 'api/lookup/Reader/update';
export const DeleteReaderLookup = 'api/lookup/Reader/delete';

//Transaction
export const GetAllTransactions = 'api/Transactions/GetAllTransactions';
export const GetAllEmployeeTransactionsForSpecificDay =
  'api/Transactions/GetAllEmployeeTransactionsForSpecificDay';

//Company
export const GetAllCompanyLookup = 'api/lookup/Company/GetAll';
export const AddCompanyLookup = 'api/lookup/Company/Add';
export const UpdateCompanyLookup = 'api/lookup/Company/update';
export const DeleteCompanyLookup = 'api/lookup/Company/delete';
export const GetAllCompanySizeLookup = 'api/lookup/Company/GetAllCompanySize';
export const GetAllCompanyTypeLookup = 'api/lookup/Company/GetAllCompanyType';
export const GetAllNoLocationsLookup = 'api/lookup/Company/GetAllNoLocations';
export const GetAllTargetEmployeesLookup =
  'api/Lookup/Company/GetAllTargetEmployees';

//Entity
export const GetAllEntityLookup = 'api/lookup/Entity/GetAll';
export const GetAllEntityPaginatedLookup = 'api/lookup/Entity/GetAllPaginated';
export const GetAllEntityByParentId = 'api/lookup/Entity/GetAllByParentID';
export const AddEntityLookup = 'api/lookup/Entity/Add';
export const UpdateEntityLookup = 'api/lookup/Entity/update';
export const DeleteEntityLookup = 'api/lookup/Entity/delete';

//Entity Level
export const GetAllEntityLevelLookup = 'api/lookup/EntityLevel/GetAll';
export const AddEntityLevelLookup = 'api/lookup/EntityLevel/Add';
export const UpdateEntityLevelLookup = 'api/lookup/EntityLevel/update';
export const DeleteEntityLevelLookup = 'api/lookup/EntityLevel/delete';

//Employee

export const GetAllEmployeeLookup = 'api/lookup/Employee/GetAll';
export const GetEmployeePaginationLookup =
  'api/lookup/Employee/GetAllPaginated';
export const AddEmployeeLookup = 'api/lookup/Employee/Add';
export const UpdateEmployeeLookup = 'api/lookup/Employee/update';
export const DeleteEmployeeLookup = 'api/lookup/Employee/delete';
export const GetAllManagersLookup = 'api/lookup/Employee/GetAllManagers';
export const GetSubordinatesLookup = 'api/lookup/Employee/GetSubordinates';
export const GetEmployeesByEntityId = 'api/lookup/Employee/GetAllByEntityId';
export const GetEmployeesByNumber = 'api/lookup/Employee/GetByNo';
export const GetEmployeeByID = 'api/lookup/Employee/GetByID';
//Employee Type
export const GetAllEmployeeTypeLookup = 'api/lookup/EmployeeType/GetAll';
export const AddEmployeeTypeLookup = 'api/lookup/EmployeeType/Add';
export const UpdateEmployeeTypeLookup = 'api/lookup/EmployeeType/update';
export const DeleteEmployeeTypeLookup = 'api/lookup/EmployeeType/delete';

//Employee Status
export const GetAllEmployeeStatusLookup = 'api/lookup/EmployeeStatus/GetAll';
export const AddEmployeeStatusLookup = 'api/lookup/EmployeeStatus/Add';
export const UpdateEmployeeStatusLookup = 'api/lookup/EmployeeStatus/update';
export const DeleteEmployeeStatusLookup = 'api/lookup/EmployeeStatus/delete';

// //Employee
export const GetAllActiveEmployeeLookup = 'api/lookup/Employee/GetAll';

//Form
export const GetAllFormControlLookup = 'api/Lookup/Form/GetAllControlTypes';
export const AddFormLookup = 'api/Lookup/Form/Add';
export const UpdateFormLookup = 'api/Lookup/Form/update';
export const GetFormLookup = 'api/Lookup/Form/GetAll';
export const GetFormByWorkFlowlookup = 'api/Lookup/Form/GetFormByWorkFlow';
export const DeleteFormlookup = 'api/Lookup/Form/Delete';
//Leave Defintion
export const AddLeaveDefinitionLookup = 'api/Lookup/LeaveSetting/Add';
export const UpdateLeaveDefinitionLookup = 'api/Lookup/LeaveSetting/update';
export const GetLeaveDefinitionLookup = 'api/Lookup/LeaveSetting/GetAll';
export const DeleteLeaveDefinitionLookup = 'api/lookup/LeaveSetting/delete';
export const GetAllEmployeeLeavesLookup = 'api/Lookup/Employee/GetAllLeaves';

//Employee Group
export const AddEmployeeGroupLookup = 'api/Lookup/EmployeeGroup/Add';
export const UpdateEmployeeGroupLookup = 'api/Lookup/EmployeeGroup/update';
export const GetEmployeeGroupLookup = 'api/Lookup/EmployeeGroup/GetAll';
export const DeleteEmployeeGroupLookup = 'api/lookup/EmployeeGroup/delete';

//Work Flow

export const AddWorkFlowLookup = 'api/Lookup/WorkFlow/Add';
export const UpdateWorkFlowLookup = 'api/Lookup/WorkFlow/update';
export const GetWorkFlowLookup = 'api/Lookup/WorkFlow/GetAll';
export const DeleteWorkFlowLookup = 'api/lookup/WorkFlow/delete';
export const GetWorkFlowAssignTypesLookup =
  'api/Lookup/WorkFlow/GetAllAssignTypes';
export const GetWorkFlowStagesLookup = 'api/Lookup/WorkFlow/GetAllStages';
export const GetFullWorkFlowDetailsLookup =
  'api/Lookup/WorkFlow/GetFullWorkFlowDetails';

//Policy
export const AddPolicyLookup = 'api/Lookup/Policy/Add';
export const UpdatePolicyLookup = 'api/Lookup/Policy/update';
export const GetPolicyLookup = 'api/Lookup/Policy/GetAll';
export const GetFilterPolicyLookup = 'api/Lookup/Policy/Filter';
export const DeletePolicyLookup = 'api/lookup/Policy/delete';
export const ChangePolicyPriorityLookup =
  'api/lookup/Policy/ChangePolicyPriority';

//Notification
export const GetNotificationTypesLookup =
  'api/Lookup/Notification/GetNotificationTypes';
export const AddNotificationLookup = 'api/Lookup/Notification/Add';
export const UpdateNotificationLookup = 'api/Lookup/Notification/Update';
export const DeleteNotificationLookup = 'api/Lookup/Notification/Delete';
export const GetNotificationLookup = 'api/Lookup/Notification/GetAll';
export const GetByIDNotificationLookup = 'api/Lookup/Notification/GetByID';

//Manager

export const AddManagerDelegationLookup = 'api/Lookup/EmployeeManager/Add';
export const GetAllManagerDelegationLookup =
  'api/Lookup/EmployeeManager/GetAll';
export const UpdateManagerDelegationLookup =
  'api/Lookup/EmployeeManager/Update';
export const DeleteManagerDelegationLookup =
  'api/Lookup/EmployeeManager/Delete';

export const GetAllEmployeelookUps = 'api/Lookup/EmployeeLookups/GetAll';
export const DeleteEmployeelookUps = 'api/Lookup/EmployeeLookups/Delete';
export const AddEmployeelookUps = 'api/Lookup/EmployeeLookups/Add';
export const UpdateEmployeelookUps = 'api/Lookup/EmployeeLookups/Update';

//RemoteWork Defintion
export const AddRemoteWorkDefinitionLookup = 'api/Lookup/RemoteWorkSetting/Add';
export const UpdateRemoteWorkDefinitionLookup = 'api/Lookup/RemoteWorkSetting/update';
export const GetRemoteWorkDefinitionLookup = 'api/Lookup/RemoteWorkSetting/GetAll';
export const DeleteRemoteWorkDefinitionLookup = 'api/lookup/RemoteWorkSetting/delete';
export const GetAllEmployeeRemoteWorksLookup = 'api/Lookup/Employee/GetAllRemoteWorks';

//Employee Entity Privilages
export const GetAllEmployeeEntityPrivilagesLookup = 'api/Lookup/Employee/GetAllEmployeeEntityPrivilege';
export const AddEmployeeEntityPrivilagesLookup  = 'api/Lookup/Employee/SaveEmployeeEntityPrivilege';
export const DeleteEmployeeEntityPrivilagesLookup = 'api/Lookup/Employee/DeleteEmployeeEntityPrivilege';

//Employee Contract
export const GetAllEmployeeContractLookup = 'api/Lookup/Employee/GetAllEmployeeContract';
export const AddEmployeeContractLookup  = 'api/Lookup/Employee/SaveEmployeeContract';
export const DeleteEmployeeContractLookup = 'api/Lookup/Employee/DeleteEmployeeContract';




// // Break Definition
// export const GetAllBreakDefinition = 'api/break-definition/get-all';
// export const AddBreakDefinition = 'api/break-definition/add';
// export const UpdateBreakDefinition = 'api/break-definition/update';
// export const DeleteBreakDefinition = 'api/break-definition/delete';

// // Meta Data
export const GetAllMetaData = 'api/meta-data/get-all';